import { useState } from 'react';
import type { WatchEvent } from '../../types';
import EventDetails from './EventDetails';
import { tierTone } from './tierTone';

/** One alert as a box: its tier, headline and why it matters, opening onto its details.
 *  `tier` false inside a check, whose card says the tier once. */
export default function AlertBox({ event, tier = true }: { event: WatchEvent; tier?: boolean }) {
  const [open, setOpen] = useState(false);
  const tone = tierTone(event.tier);
  return (
    <li className="rounded border border-gray-200 px-2.5 py-2 dark:border-gray-700">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="block w-full text-left">
        {tier && (
          <span className={`mr-2 rounded px-1.5 py-0.5 text-[10px] font-medium ${tone.chip}`} title={tone.hint}>
            {tone.label}
          </span>
        )}
        <span className="text-sm text-gray-900 dark:text-gray-100">{event.headline}</span>
        {event.so_what && <p className="mt-0.5 text-xs text-gray-600 dark:text-gray-300">{event.so_what}</p>}
        <span className="mt-0.5 inline-block text-[11px] text-indigo-600 dark:text-indigo-300">
          {open ? 'Hide details ▾' : 'Details ▸'}
        </span>
      </button>
      {open && <EventDetails event={event} />}
    </li>
  );
}
